"use client"

interface CareerTabsProps {
  activeTab: string
  onTabChange: (tab: string) => void
}

const tabs = ["Learning Path", "My Learning Journey",]

export function CareerTabs({ activeTab, onTabChange }: CareerTabsProps) {
  return (
    <div className="border-b border-slate-200">
      <nav aria-label="Tabs" className="flex flex-wrap -mb-px">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => onTabChange(tab)}
            className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm sm:px-4 transition-colors ${
              activeTab === tab
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
            }`}
          >
            {tab}
          </button>
        ))}
      </nav>
    </div>
  )
}
